export const billableStatuses = {
  billable: 'Billable',
  nonBillable: 'Non-billable',
};
